module.exports = __webpack_public_path__ + "img/homeBuilding.8bd8344e.jpg";